declare namespace $ {

	type $mol_text__text_shm_ba_converter_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_string__hint_shm_ba_converter_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_ba_converter_3 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['limit_text'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__type_shm_ba_converter_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['type'] >
	>
	type $mol_string__keyboard_shm_ba_converter_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['keyboard'] >
	>
	type $mol_view__sub_shm_ba_converter_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_download__title_shm_ba_converter_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__file_name_shm_ba_converter_8 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['csv_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__blob_shm_ba_converter_9 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['csv_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__title_shm_ba_converter_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__file_name_shm_ba_converter_11 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['parquet_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__blob_shm_ba_converter_12 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['parquet_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__title_shm_ba_converter_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__file_name_shm_ba_converter_14 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['duckdb_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_button_download__blob_shm_ba_converter_15 = $mol_type_enforce<
		ReturnType< $shm_ba_converter['duckdb_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_view__sub_shm_ba_converter_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_ba_converter extends $mol_list {
		Limit_label( ): $mol_text
		limit_text( next?: string ): string
		Limit( ): $mol_string
		Limit_row( ): $mol_view
		csv_file_name( ): string
		csv_blob( ): any
		Csv( ): $mol_button_download
		parquet_file_name( ): string
		parquet_blob( ): any
		Parquet( ): $mol_button_download
		duckdb_file_name( ): string
		duckdb_blob( ): any
		Duckdb( ): $mol_button_download
		Format_row( ): $mol_view
		data( ): any
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=converter.view.tree.d.ts.map